import React, { useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { collection, getDocs, orderBy, query } from "firebase/firestore"; // Firestore functions
import "./speaker.css";
import { db } from "../firebaseConfig";

const CommitteeSection = () => {
  const [showAll, setShowAll] = useState(true);
  const [committees, setCommittees] = useState<any[]>([]); // State for speakers data

  const placeholderImage =
    "https://res.cloudinary.com/astcdubai/image/upload/v1736906559/placeholder_male.jpg";

  useEffect(() => {
    const fetchCommittees = async () => {
      const registrationsRef = collection(db, "committees");
      try {
        const q = query(registrationsRef, orderBy("timestamp", "asc"));
        const querySnapshot = await getDocs(q);

        const committeesData: any[] = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setCommittees(committeesData);
      } catch (error) {
        console.error("Error fetching committees data:", error);
      }
    };

    fetchCommittees();
  }, []);

  const visibleCommittees = showAll ? committees : committees.slice(0, 5);

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const fetchCommittees = async () => {
      const registrationsRef = collection(db, "committees");
      try {
        const q = query(registrationsRef, orderBy("timestamp", "asc"));
        const querySnapshot = await getDocs(q);

        let committeesData: any[] = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // ✅ Always move "Honorary Chairman" to the top
        committeesData = committeesData.sort((a, b) => {
          const isHonoraryA =
            a.role?.toLowerCase().includes("honorary chairman") || false;
          const isHonoraryB =
            b.role?.toLowerCase().includes("honorary chairman") || false;
          if (isHonoraryA && !isHonoraryB) return -1; // a comes first
          if (!isHonoraryA && isHonoraryB) return 1; // b comes first
          return 0; // keep order otherwise
        });

        setCommittees(committeesData);
      } catch (error) {
        console.error("Error fetching committees data:", error);
      }
    };

    fetchCommittees();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 800) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
    };

    // Check screen size on initial load
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section id="committee" className="speakers pt-120 pb-80 brd-bottom">
      <div className="container">
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2 mb-100 text-center">
            <h1 className="title">Committee</h1>
          </div>
        </div>

        {!isSmallScreen ? (
          <div className="committee-grid">
            <TransitionGroup component={null}>
              {visibleCommittees.map((committee) => (
                <CSSTransition
                  key={committee.id}
                  timeout={500}
                  classNames="fade"
                >
                  <div className="committee-card">
                    <div className="block-speaker">
                      <div className="block-img soft">
                        <div className="speaker-img">
                          <img
                            src={committee.imageUrl || placeholderImage}
                            alt={committee.name}
                          />
                        </div>
                        <div className="block-info-2">
                          <p>
                            <strong>{committee.name}</strong>
                            <span>{committee.role}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
        ) : (
          <div className="speakers-grid">
            {visibleCommittees.map((committee) => (
              <CSSTransition key={committee.id} timeout={500} classNames="fade">
                <div className="speaker-card">
                  <div className="block-speaker">
                    <div className="block-img soft">
                      <div className="speaker-img">
                        <img
                          src={committee.imageUrl || placeholderImage}
                          alt={committee.name}
                        />
                      </div>
                      <div className="block-info-2">
                        <p>
                          <strong>{committee.name}</strong>
                          <span>{committee.role}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </CSSTransition>
            ))}
          </div>
        )}
      </div>

      {committees.length > 5 && (
        <div className="row text-center mt-20">
          <h3 className="sub-title-2">
            {!showAll ? "View all committees" : ""}
          </h3>

          <div
            className={`btn-primary ${showAll ? "view-less" : ""}`}
            onClick={() => setShowAll(!showAll)}
          >
            <span className={`arrow ${showAll ? "up" : "down"}`}></span>
          </div>
          <h3 className="sub-title-2">{!showAll ? "" : "View less"}</h3>
        </div>
      )}
    </section>
  );
};

export default CommitteeSection;
